import classNames from "classnames";
import React, { useState, useEffect, useMemo, useRef, memo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useTypeDecription from "../../hooks/useTypeDecription";
import { getCardTypeQr } from "../../page/FirstScreen/cardTypeQr";
import styled from "styled-components";
import ArrowDown from "../../components/selectCategory/svg/ArrowDown";
import useIsNoIframe from "../../hooks/useIsNoIframe";
import { webView } from "../../variables/webView";

export default memo(function NavigateCards() {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.cartType,
  }));

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isNoIframe } = useIsNoIframe();

  const [showMore, setShowMore] = useState(false);
  const { hideFooter, removeDescription } = useTypeDecription();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1199);
  const ulRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1199);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!ulRef.current) {
      return;
    }

    const ulElement = ulRef.current;
    const activeLiElement = ulElement.querySelector(".active");

    if (ulElement && activeLiElement) {
      ulElement.scrollTo({
        left: activeLiElement.offsetLeft - 100,
        behavior: "smooth",
      });
    }
  }, [ulRef.current]);

  const handlerTargetCard = async (id, redirect) => {
    const locale = window.location.pathname.split("/")[1].toUpperCase()
    gtag("event", "select_qr_type", {
      type: id,
      language: locale.length > 2 ? "EN" : locale,
    });
    if (id) {
      const path = pathname.split("/");
      path[1] = id;
      return navigate(path.join("/"));
    } else {
      window.open(redirect, "_blank");
    }
  };

  const CardTypeQr = useMemo(() => {
    return getCardTypeQr(lang);
  }, [lang]);

  const handleCardChange = (item) => {
    removeDescription();
    hideFooter();
    handlerTargetCard(item.nav, item.redirect, item.title);
  };

  const swapItemsById = (arr, id1, id2) => {
    const newArr = [...arr];
    const index1 = newArr.findIndex((item) => item.id === id1);
    const index2 = newArr.findIndex((item) => item.id === id2);

    if (index1 !== -1 && index2 !== -1) {
      [newArr[index1], newArr[index2]] = [newArr[index2], newArr[index1]];
    }

    return newArr;
  };

  const CardTypeQrShow = CardTypeQr.filter(
    (item) => !webView || item.id !== 46
  );

  return (
    <>
      {isNoIframe &&
        (isSmallScreen ? (
          <ScrollCardContainer className="d-flex pb-2" ref={ulRef}>
            {CardTypeQrShow.map((item) => {
              return (
                <InternalCard
                  key={item.id}
                  className={classNames(
                    "mobile d-flex align-items-center bg-white header-item cursor-pointer rounded position-relative h-100",
                    {
                      active: pathname.replace("/", "") === item.nav,
                    }
                  )}
                  onClick={() => handleCardChange(item)}
                >
                  <div className="d-flex align-items-center w-100 justify-content-between cursor-pointer">
                    <div className="d-flex overflow-hidden">
                      <div className="d-flex align-items-center pe-2 fs-5 cursor-pointer">
                        <item.img />
                      </div>
                      <div className="fw-bold cursor-pointer fs-7 d-flex align-items-center text-nowrap">
                        {item.title}
                      </div>
                    </div>
                  </div>
                </InternalCard>
              );
            })}
          </ScrollCardContainer>
        ) : (
          <CardContainer className="d-flex justify-content-center flex-wrap px-lg-5">
            {CardTypeQrShow.slice(0, showMore ? CardTypeQrShow.length : 8).map(
              (item) => {
                return (
                  <InternalCard
                    key={item.id}
                    className={classNames(
                      "d-flex align-items-center bg-white header-item rounded cursor-pointer position-relative h-100",
                      {
                        active: pathname.split("/")[1] === item.nav,
                        expanded: showMore,
                      }
                    )}
                    onClick={() => handleCardChange(item)}
                  >
                    <div className="d-flex align-items-center w-100 justify-content-between cursor-pointer">
                      <div className="d-flex overflow-hidden">
                        <div className="d-flex align-items-center pe-2 fs-5 cursor-pointer">
                          <item.img />
                        </div>
                        <div className="fw-bold cursor-pointer fs-7 d-flex align-items-center">
                          {item.title}
                        </div>
                      </div>
                    </div>
                  </InternalCard>
                );
              }
            )}
            <InternalCard
              className="d-flex justify-content-center align-items-center bg-white header-item cursor-pointer rounded position-relative py-2"
              onClick={() => setShowMore(!showMore)}
            >
              <ArrowDown deg={showMore ? 180 : 0} />
            </InternalCard>
          </CardContainer>
        ))}
    </>
  );
});

const CardContainer = styled.div`
  margin-left: -15px;
  margin-bottom: 10px;
`;

const ScrollCardContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin-bottom: 15px;
  scrollbar-width: auto;
  -ms-overflow-style: auto;
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #dde0e4;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const InternalCard = styled.div`
  &:hover {
    background-color: #eddcf0 !important;
    color: #9b27af;
    .card-outline {
      display: inline-block;
      height: 4px;
      background-color: #9b27af;
    }
  }
  padding: 8px 16px;
  margin-left: 15px;
  margin-bottom: 15px;

  &.mobile {
    margin-bottom: 0;
  }

  //&.expanded {
  //  min-width: 167px;
  //}

  &.active {
    background-color: #eddcf0 !important;
    color: #9b27af;
    .card-outline {
      display: inline-block;
      height: 4px;
      background-color: #9b27af;
    }
  }
`;
